import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SEO Component for dynamic meta tags
 * @param {Object} props - SEO properties
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} props.keywords - Meta keywords
 * @param {string} props.canonical - Canonical URL
 * @param {string} props.ogImage - Open Graph image URL
 * @param {string} props.ogType - Open Graph type (default: website)
 * @param {Object} props.structuredData - JSON-LD structured data
 */
const SEO = ({
  title = 'Multichannel Listing & Inventory Management System | ManageEcom',
  description = 'ManageEcom is a comprehensive eCommerce management software for multi-channel inventory, order processing, payment reconciliation, and business management.',
  keywords = 'inventory management, ecommerce management, multichannel selling, order management, stock management, ManageEcom',
  canonical = 'https://www.manageecom.com',
  ogImage = 'https://manageecom.com/static/media/manageEcom-logo.c261db53d16211e297a0.png',
  ogType = 'website',
  structuredData = null,
  author = 'ManageEcom',
  twitterCard = 'summary_large_image'
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="ManageEcom" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      <meta property="twitter:image:alt" content={title} />
      <meta name="twitter:creator" content="@manageecom" />
      <meta name="twitter:site" content="@manageecom" />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
